module.exports = __webpack_public_path__ + "img/logo_icon.b9099582.svg";